import * as React from 'react';
import { ChevronDown } from 'lucide-react';
import { cn } from '@/lib/utils';

/**
 * Native `<select>` styled as a sibling of `<Input>`. The browser draws the
 * built-in dropdown arrow at a FIXED inset from the border box that
 * `padding-right` does not move (verified in Chromium: px-2, px-3 and pr-8 all
 * render the caret at the same spot), so the control turns the native arrow off
 * with `appearance-none` and draws its own chevron at `right-3` — the same 12px
 * gutter `<Input>` uses for its text.
 *
 * Width comes from the caller's className on the select itself (`w-full`,
 * `w-72`, …); the wrapper shrinks to fit it.
 */
export const Select = React.forwardRef<HTMLSelectElement, React.SelectHTMLAttributes<HTMLSelectElement>>(
  ({ className, children, ...props }, ref) => (
    <div className="relative">
      <select
        ref={ref}
        className={cn(
          'flex h-9 appearance-none rounded-[var(--radius-ctl)] border border-input bg-background pl-3 pr-9 text-sm shadow-sm',
          'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring',
          'disabled:cursor-not-allowed disabled:opacity-50',
          className,
        )}
        {...props}
      >
        {children}
      </select>
      <ChevronDown
        className="pointer-events-none absolute right-3 top-1/2 size-4 -translate-y-1/2 opacity-50"
        aria-hidden="true"
      />
    </div>
  ),
);
Select.displayName = 'Select';
